module.exports = __webpack_public_path__ + "img/dinkenclave_cover1.9a1b4d4d.jpeg";